var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBaseModal',_vm._g({attrs:{"title":_vm.title,"modal-width":960}},_vm.$listeners),[_c('AppScrollbarContainer',{staticClass:"embedded-contact-form-modal"},[_c('IframeFormWrapper',{attrs:{"form-url":_vm.formUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }